import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import MainLayout from "../../Layout/mainLayout";
import { useDispatch, useSelector } from "react-redux";
import { addNewState, viewCountry } from "../../Redux/Actions/settingsActions";
import toast from "react-hot-toast";
import "./addState.css";

const AddState = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { country } = useSelector((state) => state.country);
  const { loading = false } = useSelector((state) => state.states || {});
  const { isAdded } = useSelector((state) => state.states || {});

  useEffect(() => {
    if (isAdded) {
      setStateData({ state_name: "", country: id });
      setErrors({});
    }
  }, [isAdded, id]);


  const [stateData, setStateData] = useState({
    state_name: "",
    country: id,
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    dispatch(viewCountry(id));
  }, [id, dispatch]);

  const validate = () => {
    const newErrors = {};

    if (!stateData.state_name.trim()) {
      newErrors.state_name = "State name is required";
    } else if (stateData.state_name.trim().length < 2) {
      newErrors.state_name = "State name must be at least 2 characters";
    } else if (stateData.state_name.trim().length > 100) {
      newErrors.state_name = "State name must be under 100 characters";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validate()) {
      toast.error("Please fix the errors before submitting");
      return;
    }
    try {
      const response = await dispatch(addNewState(stateData));
      if (response?.statusCode === 200) {
        toast.success("State added successfully!");
        setStateData({ state_name: "", country: id });
        setErrors({});
        // navigate(-1);
      }
    } catch (error) {
      toast.error(error?.message || "Failed to add state");
    }
  };

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setStateData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const countryName = country?.data?.country_name || "N/A";

  return (
    <MainLayout>
      <div className="ast-wrapper">
        {/* Header */}
        <div className="ast-header">
          <div className="ast-header-left">
            <div className="ast-header-icon">
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                <polyline points="9 22 9 12 15 12 15 22" />
              </svg>
            </div>
            <div>
              <h1 className="ast-title">Add State</h1>
              <p className="ast-subtitle">Fill in the details to add a new state</p>
            </div>
          </div>
          <button onClick={() => navigate(-1)} className="ast-view-btn" type="button">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
              <polyline points="9 22 9 12 15 12 15 22" />
            </svg>
            View State List
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="ast-form" noValidate>

          {/* Section 01: Location Context */}
          <div className="ast-section">
            <div className="ast-section-header">
              <span className="ast-section-badge">01</span>
              <h2 className="ast-section-title">Location Context</h2>
            </div>
            <div className="ast-grid ast-grid-1">
              <div className="ast-field">
                <label className="ast-label">Country</label>
                <div className="ast-readonly-wrap">
                  <span className="ast-readonly-icon">
                    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="2" y1="12" x2="22" y2="12" />
                      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
                    </svg>
                  </span>
                  <input
                    className="ast-input ast-input--readonly"
                    type="text"
                    value={countryName}
                    readOnly
                    disabled
                  />
                </div>
              </div>
            </div>
          </div>

          {/* Section 02: State Information */}
          <div className="ast-section">
            <div className="ast-section-header">
              <span className="ast-section-badge">02</span>
              <h2 className="ast-section-title">State Information</h2>
            </div>
            <div className="ast-grid ast-grid-1">
              <div className="ast-field">
                <label className="ast-label">
                  State Name <span className="ast-req">*</span>
                </label>
                <input
                  className={`ast-input ${errors.state_name ? "ast-input--error" : ""}`}
                  type="text"
                  name="state_name"
                  value={stateData.state_name}
                  onChange={handleAddChange}
                  placeholder="e.g. Maharashtra"
                  disabled={loading}
                  maxLength={100}
                />
                {errors.state_name && (
                  <span className="ast-error-msg">
                    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                      <circle cx="12" cy="12" r="10" />
                      <line x1="12" y1="8" x2="12" y2="12" />
                      <line x1="12" y1="16" x2="12.01" y2="16" />
                    </svg>
                    {errors.state_name}
                  </span>
                )}
                <span className="ast-char-count">{stateData.state_name.length}/100</span>
              </div>
            </div>
          </div>

          {/* Footer */}
          <div className="ast-footer">
            <button
              type="button"
              className="ast-btn ast-btn--cancel"
              onClick={() => navigate(-1)}
              disabled={loading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="ast-btn ast-btn--submit"
              disabled={loading}
            >
              {loading ? (
                <><span className="ast-spinner" />Saving...</>
              ) : (
                <>
                  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                    <polyline points="20 6 9 17 4 12" />
                  </svg>
                  Save State
                </>
              )}
            </button>
          </div>
        </form>
      </div>
    </MainLayout>
  );
};

export default AddState;